import React from "react";
import { UAParser } from "ua-parser-js";
const parser = new UAParser();
const osVersion = parser.getOS().version;
export default osVersion;